import {
  LanguageSpokenResponse,
  LanguageToTeachResponse,
  GetLanguageDetial,
  ReviewsStatus,
} from "../pages/reviews/types";
import { ActionType, API_URL, LanguageReviewType } from "../utils/constants";
import { getRequest, updateRequest } from "./api.service";

export const listLanguageToTeach = async (
  status: ReviewsStatus
): Promise<LanguageToTeachResponse> => {
  const data = await getRequest<LanguageToTeachResponse>(
    `${API_URL}/teachers/language-update?category=${LanguageReviewType.TEACH}&status=${status}`
  );
  return data;
};

export const fetchReviewsByStatus = async <T>(endpoint: string): Promise<T> => {
  const data = await getRequest<T>(`${API_URL}/${endpoint}`);
  return data;
};

export const listLanguageSpoken = async (): Promise<LanguageSpokenResponse> => {
  const data = await getRequest<LanguageToTeachResponse>(
    `${API_URL}/teachers/language-update?category=${LanguageReviewType.SPOKEN}`
  );
  return data;
};

export const getDetails = async (
  endpoint: string
): Promise<GetLanguageDetial> => {
  const data = await getRequest<GetLanguageDetial>(`${API_URL}/${endpoint}`);
  return data;
};

export const updateData = async (
  endpoint: string,
  body: { reqid: number; action: ActionType }
): Promise<any> => {
  const data = await updateRequest<GetLanguageDetial>(
    `${API_URL}/${endpoint}`,
    body
  );
  return data;
};
